import './ScrollButton.css'

export default function ScrollButton(props)
{
    return (
        <button
            onClick={() => { window.scrollTo({ top: window.innerHeight, behavior: 'smooth' }) }}
            className={`scroll-down-button ${props.visible && 'visible'}`}
        >Find out more about this cause</button>
    )
}